var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"small":"","icon":""}},on),[_c('v-icon',{attrs:{"small":"","color":"grey lighten-1"}},[_vm._v("free_breakfast")])],1)]}}])},[_c('span',[_vm._v("Breakfast Included")])])
}
var staticRenderFns = []

export { render, staticRenderFns }